export enum BadgeSize {
  SMALL = 'small',
  BIG = 'big',
}

export enum BadgeType {
  NEUTRAL = 'neutral',
  SUCCESS = 'success',
  FAILURE = 'failure',
}
